module.exports = __webpack_public_path__ + "img/687397a77d529c6c0e0829ab1f17ad10.svg";